<h1 mat-dialog-title class="timeout-title">Session Timeout Warning</h1>
<div mat-dialog-content class="timeout-content">
  <p class="timeout-message">
    You will be logged out in <span class="time-left">{{ timeLeft }}</span> seconds due to inactivity.
  </p>
</div>
<div mat-dialog-actions class="timeout-actions">
  <button mat-button class="cancel-button" (click)="onCancel()">Stay Logged In</button>
  <button mat-button class="logout-button" (click)="onLogout()">Logout Now</button>
</div>
